import PropTypes from "prop-types";
import ReactSelect from "react-select";
import "../assets/css/components.css";

const changeHandler = (e, props) => {
  let value = null;
  if (e) value = e.value;
  props.onChangeFunc(value, props.name, e);
  if (!props.onValidateFunc) return;
  let msg = null;
  if (!value && props.isReq) {
    msg = `Please select ${props.title}.`;
  }
  props.onValidateFunc(msg, props.name);
};

export const Dropdown = ({
  name = "",
  title = "",
  placeholder = "",
  isClearable = true,
  value = "",
  options = [],
  onChangeFunc = () => {},
  isReq = null,
  onValidateFunc = () => {},
  errorMsg,
  isMandatory = true,
}) => {
  const inputProps = {
    name,
    placeholder: placeholder || `Select ${title}`,
    isClearable,
    value: options.find((x) => x.value === value),
    options,
  };

  return (
    <div className="wrapper">
      <label className="form-label">
        {title}
        {isMandatory && <span className="mandatory-field">*</span>}
      </label>
      <ReactSelect
        {...inputProps}
        className="field"
        onChange={(e) =>
          changeHandler(e, { name, title, onChangeFunc, onValidateFunc, isReq })
        }
        menuPortalTarget={document.body}
        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
      />
      {errorMsg && <span className="error-message">{errorMsg}</span>}
    </div>
  );
};

Dropdown.propTypes = {
  name: PropTypes.string,
  title: PropTypes.string,
  placeholder: PropTypes.string,
  isClearable: PropTypes.bool,
  value: PropTypes.any,
  options: PropTypes.array,
  onChangeFunc: PropTypes.func,
  isReq: PropTypes.bool,
  errorMsg: PropTypes.any,
  onValidateFunc: PropTypes.func,
  isMandatory: PropTypes.bool,
};
